import React, { Component } from "react";
import { connect } from "react-redux";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import PropTypes from "prop-types";
import { setActiveProject } from "../../actions/ui";
import { selectFilteredProjectsInActiveFeature } from "../../reducers/";
import { projectShape } from "../../modules/project";
import styles from "./listview.module.scss";

class Listview extends Component {
    render() {
        return (
            <div>
                <hr />
                <div className={styles.container}>
                    <p>{this.props.projects.length} projects</p>
                    <BootstrapTable
                        data={this.props.projects}
                        striped={false}
                        hover={false}
                        pagination={true}
                        options={{
                            sizePerPage: 5,
                            sizePerPageList: [5, 10, 15],
                        }}
                    >
                        <TableHeaderColumn
                            dataField="Project Title"
                            isKey={true}
                            dataSort={true}
                            width="50%"
                            dataFormat={(cell, row) => (
                                <a
                                    style={{ cursor: "pointer" }}
                                    alt={"View details for: " + cell}
                                    href={""}
                                    onClick={e => {
                                        e.preventDefault();
                                        this.props.setActiveProject(row);
                                    }}
                                >
                                    {cell}
                                </a>
                            )}
                        >
                            Name
                        </TableHeaderColumn>

                        <TableHeaderColumn
                            dataField="Project NSW Electorate"
                            dataFormat={cell => cell + " electorate"}
                            dataSort={true}
                        >
                            Electorate
                        </TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    projects: selectFilteredProjectsInActiveFeature(state),
});
const mapDispatchToProps = { setActiveProject };

Listview.propTypes = {
    setActiveProject: PropTypes.func.isRequired,
    projects: PropTypes.arrayOf(PropTypes.shape(projectShape)),
};
export default connect(mapStateToProps, mapDispatchToProps)(Listview);



// WEBPACK FOOTER //
// ./src/components/listview/listview.js